"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hoverable = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var react_1 = __importStar(require("react"));
var Hoverable = function (_a) {
    var children = _a.children, _b = _a.isEnabled, isEnabled = _b === void 0 ? true : _b, onIsHoveringChanged = _a.onIsHoveringChanged, style = _a.style, setIsHoveringFromParent = _a.setIsHoveringFromParent, isHoveringFromParent = _a.isHoveringFromParent;
    var _c = __read((0, react_1.useState)(false), 2), isHoveringHook = _c[0], setIsHoveringHook = _c[1];
    var setIsHovering = setIsHoveringFromParent ? setIsHoveringFromParent : setIsHoveringHook;
    var isHovering = isHoveringFromParent ? isHoveringFromParent : isHoveringHook;
    var updateHovering = function (newIsHovering) {
        if (onIsHoveringChanged && newIsHovering !== isHovering) {
            onIsHoveringChanged(newIsHovering);
        }
        setIsHovering(newIsHovering);
    };
    return (react_1.default.createElement("div", { "data-ta-locator": "hoverable", style: style, onMouseEnter: isEnabled ? function () { return updateHovering(true); } : undefined, onMouseLeave: isEnabled ? function () { return updateHovering(false); } : undefined, onTouchStart: isEnabled ? function () { return updateHovering(true); } : undefined }, children(isHovering)));
};
exports.Hoverable = Hoverable;
exports.Hoverable.displayName = "Hoverable";
//# sourceMappingURL=Hoverable.js.map